<template>
  <div
    data-testid="team-jersey"
    :class="[layoutClass, classes.container, 'team-jersey']"
  >
    <div :class="classes.body">
      <svg style="width: 100%; height: 100%;" viewBox="0 0 312 312">
        <defs>
          <linearGradient
            id="linearGradient-1"
            x1="3.967%"
            y1="3.362%"
            x2="82.02%"
            y2="94.266%"
          >
            <stop stopColor="#FFF" stopOpacity="0.085" offset="0%" />
            <stop stopColor="#FFF" stopOpacity="0.03" offset="20%" />
            <stop stopColor="#FFF" stopOpacity="0.1" offset="40%" />
            <stop stopColor="#FFF" stopOpacity="0.03" offset="60%" />
            <stop stopColor="#FFF" stopOpacity="0.06" offset="80%" />
            <stop stopColor="#FFF" stopOpacity="0" offset="100%" />
          </linearGradient>

          <path
            id="path-2"
            d="M156.15 13.58c8.48 0 16.95-.2 25.42-.58 5.06 0 6.47 7.84 13.4 10a63.9 63.9 0 0 1 9.25 3.66c4.67 2.14 35.4 15.24 48.96 20.8 13.56 5.58 16.52 16.46 18.16 20.57 5.45 10.84 4.32 29.53 4.32 37.16v27.13c0 2.15-.62 2.76-3.12 3.74-12.74 4.34-32.02 3.2-36.3 3.2-4.27 0-4.33-2.03-5.15-4.14-.54-1.4-.54-7.1 0-17.07-.55-2.82-1.08-3.65-1.6-2.48-3.62 7.08-8.92 44.57-10 55.91-1.1 11.34-.87 30-.87 36.29 0 6.28 2.2 21.94 2.92 28.22a971 971 0 0 0 3.31 24.54c.68 4.52 1.74 8.66 2.79 12.85.74 1.9 0 3.79-1.05 5.2-1.05 1.43-5.97 4.68-12.55 8.14-6.59 3.46-14.81 5.27-20.91 6.12-6.1.86-21.65 2.3-36.98 2.3-15.32 0-29.61-1.19-36.97-2.3-7.36-1.1-13.74-2.66-20.91-6.12-7.18-3.46-11.5-6.71-12.55-8.13-1.05-1.42-1.79-3.3-1.05-5.21 1.05-4.2 2.1-8.33 2.78-12.85a971.72 971.72 0 0 0 3.32-24.54c.72-6.28 2.92-21.94 2.92-28.22 0-6.29.22-24.95-.87-36.29-1.08-11.34-6.38-48.83-10-55.91-.52-1.17-1.06-.34-1.6 2.48.54 9.98.54 15.67 0 17.07-.83 2.11-.89 4.14-5.16 4.14-4.27 0-23.56 1.14-36.3-3.2-2.5-.98-3.1-1.6-3.1-3.74v-27.13c0-7.63-1.14-26.32 4.3-37.16 1.65-4.11 4.6-15 18.17-20.56a2812.85 2812.85 0 0 0 48.96-20.81c4.67-2.15 5.2-2.15 8.1-3.28 8.27-1.75 9.48-10.38 14.55-10.38 8.47.39 16.94.58 25.41.58z"
          />

          <filter
            id="filter-4"
            x="-5.7%"
            y="-3%"
            width="111.4%"
            height="109.6%"
            filterUnits="objectBoundingBox"
          >
            <feMorphology
              radius="0.578"
              operator="dilate"
              in="SourceAlpha"
              result="shadowSpreadOuter1"
            />
            <feOffset
              dy="5"
              in="shadowSpreadOuter1"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation="3.5"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feComposite
              in="shadowBlurOuter1"
              in2="SourceAlpha"
              operator="out"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
              in="shadowBlurOuter1"
            />
          </filter>
          <path
            id="path-5"
            d="M2.77 87.2C2.84 87.1.84 75.2.69 72.24c-.84-16.8-.84-30.15 6.2-43.9C10.87 20.54 20.85 10.06 30.6 4.3 33.9 2.35 36 1.55 39.75.58 48 11.5 55.3 15 60.8 17.7c5.5 2.7 10.97 3.97 14.89 4.13 2.24-.23 5.58-.82 13.4-4.02A64.61 64.61 0 0 0 113.23.58c4.34.82 6.21 1.61 9.79 3.72 9.76 5.77 19.73 16.25 23.71 24.03 7.04 13.76 7.04 27.1 6.2 43.91-.15 2.92-2.08 14.5-2.08 14.95-.23-.26-.46-.13-.69.38-3.62 7.08-8.92 44.57-10 55.91-1.09 11.34-.87 30-.87 36.29 0 6.28 2.2 21.94 2.92 28.22.4 3.39 1.86 14.76 3.32 24.54.67 4.52 1.73 8.66 2.78 12.85.74 1.9 0 3.79-1.05 5.2-1.05 1.43-5.96 4.68-12.55 8.14-6.58 3.46-14.8 5.27-20.9 6.12-6.1.86-21.66 2.3-36.98 2.3-15.33 0-29.62-1.19-36.98-2.3-7.36-1.1-13.73-2.66-20.9-6.12-7.18-3.46-11.5-6.71-12.55-8.13-1.05-1.42-1.8-3.3-1.05-5.21 1.05-4.19 2.1-8.33 2.78-12.85a972.81 972.81 0 0 0 3.31-24.54c.73-6.28 2.92-21.94 2.92-28.22 0-6.29.22-24.95-.86-36.29-1.09-11.34-6.39-48.83-10-55.91-.24-.53-.48-.65-.72-.36"
          />
        </defs>

        <g fill="none" fillRule="evenodd">
          <mask id="mask-3" fill="#fff">
            <use xlink:href="#path-2" />
          </mask>

          <use fill="#000" filter="url(#filter-4)" xlink:href="#path-2" />

          <use
            :fill="teamColors?.jersey.background || '#fff'"
            xlink:href="#path-2"
          />

          <path
            strokeOpacity="0.15"
            stroke="#000"
            strokeWidth="0.58"
            d="M156.15 13.29c8.47 0 16.94-.2 25.42-.58 1.88 0 3.3.93 5.1 2.98.4.44 1.76 2.09 2.02 2.4 2.13 2.46 3.91 3.87 6.36 4.63 2.85.86 4.98 1.7 9.3 3.67 4.99 2.3 36.13 15.55 48.94 20.81a29.63 29.63 0 0 1 16.42 15.93c.39.86.73 1.7 1.1 2.7l.79 2.07c2.08 4.14 3.34 9.63 3.96 16.3.48 5.12.55 9.7.43 16.98a216.2 216.2 0 0 0-.05 4v27.14c0 2.23-.62 2.96-3.3 4.02a61.23 61.23 0 0 1-12.88 2.63c-6.33.7-12.43.82-20.08.65l-2.01-.05a67.8 67.8 0 0 0-1.42-.02c-3.2 0-4.22-.87-5.09-3.38l-.33-.94c-.57-1.47-.57-7.15-.02-17.12a9.18 9.18 0 0 0-.77-2.64c-.12-.18-.11-.18-.3.23-2.97 5.82-8.3 38.36-9.97 55.8-.37 3.88-.61 8.81-.75 14.66-.12 5.58-.15 10.68-.12 18.18v3.43c0 2.77.42 7.49 1.2 14.07.11 1.04.24 2.12.38 3.26.2 1.64 1.18 9.4 1.35 10.86a968.4 968.4 0 0 0 3.3 24.52 112.43 112.43 0 0 0 2.72 12.55l.05.24c.7 1.8.22 3.72-1.08 5.49-1.12 1.52-6.2 4.83-12.65 8.21-5.77 3.04-13.24 5.07-21 6.16-8.51 1.2-24.02 2.3-37.02 2.3-13.76 0-28.36-1-37.02-2.3-8.28-1.25-14.37-2.97-20.99-6.15-6.34-3.06-11.32-6.42-12.65-8.22-1.3-1.77-1.79-3.68-1.1-5.45l.07-.28.28-1.13c1.28-5.1 1.92-8.02 2.43-11.42 1.22-8.2 2.74-19.63 3.3-24.52l1.35-10.86.4-3.26c.76-6.58 1.18-11.3 1.18-14.07v-3.43c.03-7.5.01-12.6-.12-18.18a212.2 212.2 0 0 0-.74-14.65c-1.67-17.45-7-49.99-9.98-55.82-.18-.4-.17-.4-.29-.22-.24.37-.5 1.26-.77 2.56.55 10.05.55 15.73-.02 17.2-.1.25-.1.23-.34.94-.86 2.51-1.87 3.38-5.08 3.38-.33 0-.77 0-1.42.02l-2 .05c-7.67.17-13.76.05-20.1-.65a61.22 61.22 0 0 1-12.88-2.64c-2.67-1.05-3.3-1.78-3.3-4.01v-27.13c0-.9 0-1.17-.05-4.01-.11-7.28-.04-11.86.43-16.97.63-6.68 1.88-12.17 3.96-16.29l.79-2.09c.38-1 .72-1.84 1.1-2.7A29.63 29.63 0 0 1 59.02 47.2a2821.3 2821.3 0 0 0 48.96-20.8 66.13 66.13 0 0 1 5.59-2.35l.1-.04c1.53-.55 1.64-.6 2.48-.92 3.09-.65 5.25-2.19 7.63-4.94.34-.39 1.92-2.31 2.35-2.8 1.6-1.8 2.92-2.64 4.63-2.64 8.47.39 16.94.58 25.4.58z"
          />

          <g mask="url(#mask-3)">
            <g transform="translate(79.333 28.022)">
              <mask id="mask-6" fill="#fff">
                <use xlink:href="#path-5" />
              </mask>

              <!-- Chest -->
              <use
                :fill="teamColors?.jersey.background || '#fff'"
                xlink:href="#path-5"
              />

              <!-- Squares -->
              <g
                v-if="teamColors?.jersey.squares"
                :fill="teamColors?.jersey.squares"
                mask="url(#mask-6)"
              >
                <path
                  d="M130.58 45.07h43.33V88.4c-4.3.77-10.63.93-18.97.48-13.32-.7-21.47.07-24.36-.48V45.07z"
                  transform="translate(-31.2 -78)"
                />
                <path
                  d="M38.71 46.22H80.9c.92 20.74 1.3 34.8 1.15 42.18-9.65.6-24.1.99-43.33 1.16V46.22z"
                  transform="translate(-31.2 -78)"
                />
                <path
                  d="M82.04 88.4c11.84-1.03 26.13.5 48.54 0 1.73 12.18 1.73 28.26 1.73 40.44-14.05-.42-31.13-.3-51.42 0 0-12.33.19-27.12 1.15-40.44z"
                  transform="translate(-31.2 -78)"
                />
                <path
                  d="M37.56 130.58c22.8-2.31 31.77-2.31 43.33-2.31 1.64 18.26.06 24.24 4.04 45.06H44.5c1.51-15.59-6.93-22.01-6.93-42.75z"
                  transform="translate(-31.2 -78)"
                />
                <path
                  d="M175.64 130.58c-22.8-2.31-32.42-2.31-43.33-2.31-1.29 16.46 0 22.47-4.04 45.06h40.44c-1.51-15.59 6.93-22.01 6.93-42.75z"
                  transform="translate(-31.2 -78)"
                />
                <path
                  d="M84.93 173.33c15-.88 24.58-.88 43.34 0v43.34c-3.98.54-12.73 0-21.4-.48-8.33-.46-17.47.11-22.51.48 0-11.38.57-32.5.57-43.34z"
                  transform="translate(-31.2 -78)"
                />
                <path
                  d="M128.27 216.67c5 .97 9.75.85 16.76.85 5.14 0 6.93.1 17.9-2.59-2.18 7.64 1.39 12.3 1.77 20.57.08 1.7.2 8.66.34 10.4.44 5.36.58 10.58 1.36 13.52-5.98 0-12.62 1.33-16.55 1.2-12.9-.4-6.63-1.2-21.58-.62-1.4-19.86 0-36.44 0-43.33z"
                  transform="translate(-31.2 -78)"
                />
                <path
                  d="M49.11 217.24c3.2.76 7.01-2.04 14.11-.57 9.23 1.9 10.33.76 21.14 0-.58 11.07.57 29.16 1.15 44.49-7.1.36-12.83.32-20.41.32-9.2 0-6.92-2.06-15.99-2.06-8.78-15.58 9.07-31 0-42.18z"
                  transform="translate(-31.2 -78)"
                />
                <path
                  d="M85.51 260.58c8.23.58 13.76-.83 20.77-1.04 8.1-.24 13.81 1.04 21.99.46.44 10.43.7 35.64.57 43.33-2.76.89-7.76-.24-11.03-.11-7.1.27-12.84.99-16.08 1-7.58.02-12.6-1.43-16.8-.89.86-16.96 0-30.23.58-42.75z"
                  transform="translate(-31.2 -78)"
                />
                <path
                  d="M.27 89.18l37.86-2.51c-1.2 20.46-1.4 35.1-.57 43.9-6.79.18-19.22.9-37.3 2.19V89.18z"
                  transform="translate(-31.2 -78)"
                />
                <path
                  d="M16.96 175.57a191.1 191.1 0 0 1 27.53-2.24c-3.59 20.66 6.23 31.16 4.66 43.85-9.02-.58-17.92-.76-26.68-.51l-5.51-41.1z"
                  transform="translate(-31.2 -78)"
                />
                <path
                  d="M8.67 259.42h40.51c3.89 17.23-3.7 24.03-3.7 40.45-6.7 0-18.98-2.9-36.81-8.67v-31.78z"
                  transform="translate(-31.2 -78)"
                />
                <path
                  d="M175.64 86.67h43.34v42.75c-19.13 1.88-33.57 2.26-43.34 1.16 1.27-5 1.16-16.06.83-26.23-.13-3.98-.4-9.87-.83-17.68z"
                  transform="translate(-31.2 -78)"
                />
                <path
                  d="M168.71 173.33h36.98l-3.47 41.6c-19.64-.38-32.7-.38-39.18 0 1.73-23.42 10.1-24 5.67-41.6z"
                  transform="translate(-31.2 -78)"
                />
                <path
                  d="M166.75 259.42c7.91-.89 20.31-2.83 37.2-5.83v39.34c-13.47 1.64-24.97 3.75-34.5 6.36-1.77-14.01 0-30.17-2.7-39.87z"
                  transform="translate(-31.2 -78)"
                />
                <path
                  d="M128.27 303.33c3.36-.6 11.5-.01 17.37-.76 8.67-1.12 15.9-1.61 23.65-2.7 1.15 6.17 1.15 20.62 0 43.33l-41.02 3.47c.38-17.39.38-31.83 0-43.34z"
                  transform="translate(-31.2 -78)"
                />
                <path
                  d="M45.07 299.87c6.45 1.13 12.1 1.33 17.5 2.62 5.85 1.4 15.12 1 22.36.84-.55 8.35-.55 22.8 0 43.34-19.18-1.46-33.23-2.61-42.17-3.47 1.4-15.73 2.3-32.16 2.3-43.33z"
                  transform="translate(-31.2 -78)"
                />
              </g>
              <!-- Stripes -->
              <g
                v-if="teamColors?.jersey.verticalStripe"
                :fill="teamColors?.jersey.verticalStripe"
                mask="url(#mask-6)"
              >
                <path
                  d="M68.22 0H97.7a578.06 578.06 0 0 1 4.04 68.87c0 35.13-2.24 49.64-2.89 92.12-.45 29.42.94 59.14 1.23 89.74.2 20.4 1.9 31.77 5.13 34.11H68.22c.77 8.93 1.16-1.92 1.16-32.53 0-45.92-2.17-45.8-1.74-91.84.44-46.03 1.74-55.75 1.74-90.93 0-23.46-.39-46.63-1.16-69.54z"
                  transform="translate(23.644 -11.556)"
                />
                <path
                  d="M6.98 0h30.04c-.77 19.02-1.15 42.48-1.15 70.39 0 41.85 1.15 43.28 2.3 84.08.89 31.14-.14 63.96-.3 96.28-.04 7.56-.32 18.92-.85 34.1H.04a417.76 417.76 0 0 0 4.9-34.24c3.43-32.84 1.32-73.48.88-96.58-.82-43.72-2.3-61.6-2.3-83.86C3.51 55.33 4.66 31.94 6.97 0z"
                  transform="translate(23.644 -11.556)"
                />
              </g>
              <!-- Horizontal Stripes -->
              <g
                v-if="teamColors?.jersey.horizontalStripe"
                :fill="teamColors?.jersey.horizontalStripe"
                mask="url(#mask-6)"
              >
                <path
                  d="M.58 215.46c15.67 4.08 29.31 6.42 40.94 7.03 10.75.56 29.55 2.85 40.95 3.36 16.28.72 28.9-2.8 48.42-2.8 8.61 0 22.18-3.1 40.71-9.3v24.95c-20.41 7.5-35.27 11.55-44.57 12.16-13.28.86-25.48 2.17-38.9 2.17-11.04 0-27.3-1.22-38.24-2.17-10.61-.92-27.05-4.23-49.31-9.92v-25.48z"
                  transform="translate(-8.089 -.311)"
                />
                <path
                  d="M.58 167.2c16.8 0 27.23.83 35.6 1.41 7.94.56 16.86.08 27.65.56 12.65.56 20.57 2.05 33.5 2.23 12.92.19 23.12-2.04 32.72-2.22 6.84-.13 20.5-1.25 40.97-3.36.38 13.06.58 22.23.58 27.5-10.17-.34-32.68 4.82-41.55 4.68-12.02-.2-19.43 3.1-38.24 2.39-17.55-.66-31.98-2.67-40.49-3.15-6.92-.38-12.9-.46-17.12-.93-7.8-.88-21.42-2.84-33.62-4.16-.19-5.67-.12-18.72 0-24.96z"
                  transform="translate(-8.089 -.311)"
                />
                <path
                  d="M.58 112.22c25.13-1.45 43.63-1.65 55.5-.6 9.55.84 20.7 1.42 31.62 1.06 13.92-.47 24.9-1.06 41.96-.58 13.93.39 27.91-.77 41.94-3.48v31.16c-19.47 1.18-35.13 1.47-46.98.85-11.38-.6-22.9 1.5-41.07 1.5-17.34 0-32.93-1.75-49.94-2.58-7.1-.34-18.1.13-33.03 1.43v-28.76z"
                  transform="translate(-8.089 -.311)"
                />
                <path
                  d="M.58 55.49c8.17 0 13.87-.87 22.75-1.22 13.65-.54 36.36 1.53 60.43.86 29.24-.8 41.3-.8 52.81 0 7.45.53 19.12 1.02 35.03 1.5v30.04c-17-.15-29.07-.53-36.18-1.14-14.16-1.22-25.52-.9-51.08-.05-15.7.52-35.83-1.17-47.36-1.17-10.92 0-23.05.79-36.4 2.36V55.49z"
                  transform="translate(-8.089 -.311)"
                />
                <path
                  d="M.58 1.2c22.21.06 39.22-.03 51-.27C61.99.7 72.63 0 83.49 0c12.35 0 24.69 1.34 37.03 1.62 11.35.26 28.38.12 51.09-.42V33.5a1573.81 1573.81 0 0 0-45.35-3.14c-14.7-.7-28.96-.45-42.78-.45-18.11 0-36.22-.77-54.32.09-6.35.3-15.87 1.47-28.57 3.5V1.2z"
                  transform="translate(-8.089 -.311)"
                />
              </g>
              <!-- Jersey Split -->
              <rect
                v-if="teamColors?.jersey.split"
                :fill="teamColors?.jersey.split"
                mask="url(#mask-6)"
                x="75.689"
                y="-8.667"
                width="90.711"
                height="276.178"
              />
            </g>
          </g>

          <!-- If sleeveLong -->
          <!-- Sleeve Right -->
          <path
            :fill="
              teamColors?.jersey.sleeve
                ? teamColors?.jersey.sleeve
                : teamColors?.jersey.sleeve || '#fff'
            "
            mask="url(#mask-3)"
            d="M116.42 23.25c1.51-.37 2.78-.95 3.88-1.65-.15 0-.3.02-.44.03-.65 0-2.47.63-3.33 1.03-1.91.91-8.68 4.08-13.86 6.36-5.9 2.59-10.24 4.39-9.77 4.2a3080.9 3080.9 0 0 1-33.78 14.24c-13.56 5.57-16.51 16.45-18.16 20.56-5.45 10.84-4.31 29.53-4.31 37.16v27.13c0 2.15.62 2.76 3.11 3.75 12.74 4.34 32.02 3.2 36.3 3.2 4.27 0 4.33-2.03 5.15-4.14.54-1.4.54-7.1 0-17.08.3-1.54.6-2.48.9-2.83.06-.09-1.94-12-2.08-14.96-.84-16.8-.84-30.15 6.2-43.9 3.97-7.8 13.95-18.28 23.7-24.04a46.19 46.19 0 0 1 9.23-4.03c-2.19-2.86-3.43-5.03-2.74-5.03"
          />

          <!-- Sleeve Left -->
          <path
            :fill="
              teamColors?.jersey.sleeve
                ? teamColors?.jersey.sleeve
                : teamColors?.jersey.sleeve || '#fff'
            "
            mask="url(#mask-3)"
            d="M271.35 68.02c-1.65-4.11-4.6-15-18.17-20.56-8.17-3.36-22.59-9.45-33.77-14.23.47.17-3.87-1.63-9.77-4.22a611.44 611.44 0 0 1-13.86-6.35c-.86-.41-2.68-1.04-3.33-1.04l-.35-.02c.77.48 1.6.9 2.55 1.16 1.19.52.16 2.63-2.07 5.33a46.75 46.75 0 0 1 9.8 4.22c9.75 5.76 19.73 16.24 23.7 24.03 7.04 13.75 7.04 27.1 6.2 43.9-.15 2.97-2.14 14.88-2.07 14.96.3.35.59 1.3.9 2.84-.56 9.97-.56 15.67 0 17.07.81 2.11.87 4.14 5.14 4.14 4.28 0 23.56 1.14 36.3-3.2 2.5-.98 3.11-1.6 3.11-3.74v-27.13c0-7.63 1.13-26.33-4.31-37.16"
          />

          <!-- If sleeve && sleeveLong -->
          <!-- Sleeve Stripe Right -->
          <path
            v-if="teamColors?.jersey.sleeve && teamColors?.jersey.outline"
            :fill="teamColors?.jersey.outline"
            mask="url(#mask-3)"
            d="M81.48 133.62c0 .8-.26 1.56-.4 1.83-.7 2.07-1.03 3.81-5.1 3.81-4.27 0-23.55 1.14-36.29-3.2-2.5-.99-3.11-1.6-3.11-3.74v-1-1.85c2.15 1.17 4 1.95 5.57 2.34 10.47 2.62 22.06 2.62 30.62 2.62 5.7 0 7.98-.6 8.71-.81z"
          />

          <!-- Sleeve Stripe Left -->
          <path
            v-if="teamColors?.jersey.sleeve && teamColors?.jersey.outline"
            :fill="teamColors?.jersey.outline"
            mask="url(#mask-3)"
            d="M230.8 133.63c0 .66.2 1.36.4 1.82.71 2 .99 3.8 5.05 3.8 4.27 0 23.56 1.15 36.3-3.19 2.49-.99 3.1-1.6 3.1-3.74v-2.85a24.6 24.6 0 0 1-5.56 2.34c-10.48 2.62-22.06 2.62-30.63 2.62-5.69 0-7.93-.6-8.66-.8"
          />

          <!-- Neck -->
          <path
            :fill="teamColors?.jersey.neck || '#fff'"
            mask="url(#mask-3)"
            d="M156.15 13.58l25.42-.58c5.06 0 6.6 7.96 13.08 9.75 2.81 1.26-6.8 11.41-15.59 17.22-7.71 5.1-20.24 9.59-24.18 9.59-3.94 0-13.31-2.1-24.14-9.59-6.99-4.83-15.92-16.73-14.32-16.73 8.23-2 9.25-10.24 14.32-10.24l25.41.58z"
          />

          <!-- <use fill="url(#linearGradient-1)" xlink:href="#path-2" /> -->
        </g>
      </svg>
    </div>

    <div :class="[classes.overlay]">
      <img :class="classes.overlayImg" :src="overlay" />
    </div>
  </div>
</template>
<script lang="ts">
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import { createUseStyles } from "@fresh8/vue-jss/src";

import { computed, defineComponent, PropType } from "vue";
import { injectTemplateSize } from "@fresh8/ad-data-composition/src/useTemplateSize";
import { ShortSleeveOverlay as overlay } from "../overlays/jerseys";
import { injectTeamColors } from "../../../lib/teamBranding";

const useStyles = createUseStyles({
  body: {
    width: "100%",
    height: "100%",
    alignSelf: "baseline",
    display: "flex"
  },
  overlay: {
    display: "flex",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    padding: props => props.padding
  },
  overlayImg: {
    width: "100%",
    height: "100%"
  },
  container: {
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderStyle: "solid",
    borderWidth: props => props.borderWidth,
    background: "white",
    borderRadius: "9001px",
    margin: "0",
    borderColor: props => props.borderColor,
    boxShadow: "0 2px 8px -2px rgba(0,0,0,0.16), 0 1px 2px rgba(0,0,0,.3)",
    maxWidth: "32px",
    position: "relative",
    overflow: "hidden",
    padding: props => props.padding
  }
});

export default defineComponent({
  name: "ShortSleeveJersey",
  props: {
    borderWidth: {
      type: String,
      required: false,
      default: "1px"
    },
    hideBoxShadow: {
      type: Boolean,
      required: false,
      default: false
    },
    homeOrAwayTeam: {
      type: String as PropType<"home" | "away">,
      required: true
    },
    padding: {
      type: String,
      required: false,
      default: "2px"
    }
  },
  setup(props) {
    const brandContext = injectBrand();
    const template = injectTemplateSize();

    const teamColorsContext = injectTeamColors();

    const teamColors = computed(
      () => teamColorsContext.colors.value[props.homeOrAwayTeam]
    );

    const borderColor = computed(() => {
      if (
        brandContext?.brand.value?.adTemplate?.team?.useTeamColors &&
        teamColors.value?.banner.background
      ) {
        return teamColors.value?.banner.background;
      } else {
        return brandContext?.teamBranding.value.badge.borderColor;
      }
    });

    const reactiveStyles = computed(() => ({
      borderWidth: props.borderWidth,
      borderColor:
        borderColor.value || brandContext?.teamBranding.value.badge.borderColor,
      hideBoxShadow: props.hideBoxShadow,
      padding: props.padding
    }));

    const classes = useStyles(reactiveStyles);

    return {
      teamColors,
      overlay,
      classes,
      layoutClass: computed(() => template?.size.value?.name)
    };
  }
});
</script>
